import InstalledRouter from '@/system/init/init-router';

const Products = () => import('../components/models/models');
const Login = () => import('../components/login/index');
const OrderItem = () => import('../components/order/order');
const OrderResult = () => import('../components/order-result/index');
const Orders = () => import('../components/orders/orders');

const ProductInfo = () => import('../components/inquery/inquery');
// const EvInfo = () => import('../components/ev-info/porder');
const EvInfo = () => import('../components/create-order/index');
const Search = () => import('..//components/search/search');
const D404 = () => import('@/core/404/index');
// const Active = () => import('../views/actives/index');
const Active = () => import('../views/newActive/index');

export function createRouter () {
  return new InstalledRouter({
    base: 'nby',
    mode: 'history',
    routes: [
      {
        path: '/search',
        name: 'search',
        component: Search,
        meta: {
          index: 1,
          hideCrumb: false,
          headerTitle: '搜索',
          headerFixed: true,
          title: 'title'
        }
      },
      // 加一个活动页，路由不变
      {
        path: '/products',
        name: 'active',
        component: Active,
        props: true,
        meta: {
          // index: 1,
          title: 'title'
        }
      },
      {
        path: '/products/:categoryId(\\d+)?/:brandId(\\-\\d|\\d+)?/:pageIndex(\\d+)?',
        name: 'Products',
        component: Products,
        props: true,
        meta: {
          index: 1,
          title: 'title'
        }
      },
      {
        path: '/evaluate/:productId.html',
        name: 'ProductInfo',
        component: ProductInfo,
        props: true,
        meta: {
          index: 2,
          title: 'title',
          headerTitle: '设备信息'
        }
      },
      {
        path: '/evInfo/:evID',
        name: 'EvInfo',
        component: EvInfo,
        meta: {
          index: 3,
          title: 'title',
          requiresAuth: true,
          headerTitle: '创建订单'
        }
      },
      // {
      //   path: '/initOrder/:evID',
      //   name: 'InitOrder',
      //   component: InitOrder,
      //   meta: {
      //     index: 4,
      //     title: 'title',
      //     requiresAuth: true
      //   }
      // },
      {
        path: '/orderResult/:orderNum',
        name: 'OrderResult',
        component: OrderResult,
        meta: {
          title: 'title',
          headerTitle: '提交成功'
        }
      },
      {
        path: '/login',
        name: 'Login',
        component: Login,
        meta: {
          hideHeader: true,
          hideCrumb: true,
          title: 'title'
        }
      },
      {
        path: '/order/:orderId',
        name: 'OrderItem',
        component: OrderItem,
        meta: {
          requiresAuth: true,
          title: 'title',
          headerTitle: '订单详情'
        }
      },
      {
        path: '/orders',
        name: 'Orders',
        component: Orders,
        meta: {
          requiresAuth: true,
          hideCrumb: true,
          title: 'title',
          headerTitle: '订单列表'
        }
      },
      {
        path: '/:categoryId(\\d+)?/:brandId(\\-\\d|\\d+)?/:pageIndex(\\d+)?',
        name: 'Products2',
        component: Products,
        props: true,
        meta: {
          index: 1,
          title: 'title'
        }
      },

      {
        path: '*',
        name: '404',
        component: D404,
        meta: {
          title: 'title'
        }
      }
    ]
  });
}
